import { render, staticRenderFns } from "./create-passenger-modal.vue?vue&type=template&id=c9dcffec&scoped=true"
import script from "./create-passenger-modal.vue?vue&type=script&lang=js"
export * from "./create-passenger-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9dcffec",
  null
  
)

export default component.exports